import PropTypes from 'prop-types';
import { useEffect, useRef } from 'react';
import { twMerge } from 'tailwind-merge';

const SIZES = {
  size1: 'md:w-[576px]',
  size2: 'md:w-[432px]',
  size3: '',
};

const ModalRoot = ({ className, children, size = 'size1' }) => {
  const dialogRef = useRef(null);

  // Due internal application rules, the modal was closed via `ModalRoot`
  useEffect(() => {
    dialogRef.current.showModal();
  }, []);

  return (
    <dialog
      ref={dialogRef}
      className={twMerge(
        'z-60 m-auto w-96 rounded-4 border border-neutral-high-400 outline-0 transition ease-in backdrop:fixed backdrop:inset-0 backdrop:bg-neutral-low-500/60 open:transition open:duration-150 open:ease-in supports-[backdrop-filter]:backdrop:backdrop-blur-sm dark:border-neutral-low-100 dark:bg-neutral-low-500 dark:backdrop:bg-neutral-low-500/60 [&:not([open])]:pointer-events-none [&:not([open])]:opacity-0',
        SIZES[size],
        className
      )}
      data-test-selector="modal"
      role="alertdialog"
    >
      {children}
    </dialog>
  );
};

ModalRoot.displayName = 'Modal';

ModalRoot.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  size: PropTypes.string,
};

export default ModalRoot;
